import { useState } from 'react';
import { REPORTS_COPY } from '../copy';

export default function CopyIdButton({ id }: { id: string }) {
    const [copied, setCopied] = useState(false);

    return (
        <button
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                void navigator.clipboard.writeText(id);
                setCopied(true);
                window.setTimeout(() => setCopied(false), 1200);
            }}
            className="shrink-0"
            style={{
                padding: '2px 7px',
                borderRadius: 'var(--cpm-radius-6)',
                border: '1px solid var(--cpm-border-default)',
                background: '#fff',
                fontFamily: 'var(--cpm-font-sans)',
                fontSize: 9.5,
                fontWeight: 800,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                color: 'var(--cpm-text-secondary)',
                cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--cpm-brand-purple)';
                e.currentTarget.style.color = 'var(--cpm-brand-navy)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--cpm-border-default)';
                e.currentTarget.style.color = 'var(--cpm-text-secondary)';
            }}
        >
            {copied ? REPORTS_COPY.COPIED : REPORTS_COPY.COPY_ID}
        </button>
    );
}
